// extracted by mini-css-extract-plugin
module.exports = {"root":"admin-module--root--36w4X","submit":"admin-module--submit--1hcQy"};